/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ms } from './Ms';

class UserMessageSend extends Ms {
    constructor() {
        super();
        this.baseUrl += '/userMessageSend';
    }

    data({ messageCase, messageTitle, messageContent, currentPage, pageSize } = {}) {
        return super.get('/data', {
            messageCase,
            messageTitle,
            messageContent,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then();
    }

    save({
        messageCase,
        messageTitle,
        messageContent,
        remarks,
        userMessageSendType,
        userIds,
        verticalGroupingIds,
        isSendWxmsgTemplate,
        enterpriseIds,
        isSendEnterprise,
        messageTitleA,
        messageContentA,
        remarksA,
    } = {}) {
        return super.post('/save', {
            messageCase,
            messageTitle,
            messageContent,
            remarks,
            userMessageSendType,
            userIds,
            verticalGroupingIds,
            isSendWxmsgTemplate,
            enterpriseIds,
            isSendEnterprise,
            messageTitleA,
            messageContentA,
            remarksA,
        });
    }
}

export default new UserMessageSend();
export { UserMessageSend };
